export default {
      id: "instagram-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite.svg#instagram",
      toString: function () {
        return this.url;
      }
    }